// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgPspReportsController = function ($scope, $http, $location, PgPspReports) {
    $scope.loading = true;

    const getEmptyFilter = function () {
        return {
            After: '',
            Before: '',
            PspReportId: '',
        };
    };

    $scope.filter = getEmptyFilter();

    $scope.fetchPspReports = function () {
        let queryParams = $location.search();
        if (queryParams.PspReportId)
            $scope.filter.PspReportId = queryParams.PspReportId;

        $scope.loading = true;
        $scope.pspReports = $scope.paginator(function(options, callback) {
                return PgPspReports.query(options, function()
                {
                    callback();
                    $scope.loading = false;
                });
            },
            $scope.filter,
            10);


        if ($scope.filter.PspReportId)
            queryParams["PspReportId"] = $scope.filter.PspReportId;

        $location.search(queryParams)
    }

    $scope.fetchPspReports();

    $scope.resetFilter = function () {
        $scope.filter = getEmptyFilter();
        $location.url($location.path());
    };
};
PgPspReportsController.$inject = ["$scope", "$http", "$location", "PgPspReports"];
